import { IxPageState, IxReportFilterDTO } from 'ix-ng-components';
import { ObcinaLookupDTO } from '../lib/lookup/obcina-lookup/obcina-lookup.model';
import { RowsLookupDTO } from '../lib/lookup/rows-lookup/rows-lookup.model';
import { UkrepLookupDTO } from '../lib/lookup/ukrep-lookup/ukrep-lookup.model';
import { Maybe } from 'ix-ng-static-utils';

export class VpoglednikFilterDTO extends IxReportFilterDTO {
  naziv: Maybe<string> = null;
  nazivDS: Maybe<string> = null;
  obcinaLookupSeznam: Maybe<ObcinaLookupDTO[]> = null;
  ukrepLookupSeznam: Maybe<UkrepLookupDTO[]> = null;

  skupniZnesek: Maybe<number> = null;
  skupniZnesekFrom: Maybe<number> = null;
  skupniZnesekTo: Maybe<number> = null;

  rowsLookupSeznam: Maybe<RowsLookupDTO[]> = null;
}

export class UvozLogDTO {
  datumUvoza: Maybe<Date> = null;
  vrstaUvoza: Maybe<string> = null;
  stVrstic: Maybe<number> = null;
  leto: Maybe<number> = null;
}

export class GroupDTO {
  id: Maybe<string> = null;
  isCollapsed: Maybe<boolean> = null;
}

export const VpoglednikPageState = new IxPageState();
export const ROUTER_IDENTIFIER_LETO = 'leto';
export const ROUTER_IDENTIFIER_JEZIK = 'jezik';
